<template>
  <div class="padded">
  <el-col align="left">

  <edit-pane v-if="!hidePanel" ref="tpe" prefix="Ticket: ":title="this.formatCategory(ticket.category)"
    :is-edit="editMode"
    @save="onSave"
    @cancel="onCancel"
    @delete="onDelete"
    @edit="onEdit"
    @add="onSave" />

    <p>Ticket Ref: <b><a :href="'mailto:?subject=re: Ticket ' + ticketRef + ' - ' + localData.category + ' for: ' + localData.site.siteName + ' [Status: ' + localData.status + ']'">{{ticketRef}}</a></b></p>

  <el-form ref="maintForm" :model="ticket" label-width="120px">
    <el-tabs :type="this.isTowerCo() ? 'card' : ''">
      <el-tab-pane label="Issue">

        <select-site v-if="!localSiteId" v-model="localData.site_id" required />

        <select-ticket-category v-model="localData.category" :disabled="disabled" />

        <el-row style="clear: both;">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :hg="8">
            <select-action-status v-model="localData.status" :disabled="disabled" />
          </el-col>

          <el-col :xs="24" :sm="24" :md="12" :lg="8" :hg="8">
            <select-priority v-model="localData.priority" :disabled="disabled" />
          </el-col>

          <el-col :xs="24" :sm="24" :md="12" :lg="8" :hg="8">
            <date-input
              label="Target"
              v-model="ticket.target"
              :options="dateOptions"
              :disabled="disabled" />
            </el-col>

        </el-row>

        <el-row  v-if="this.isTowerCo() && ticket.status === 'Completed' || ticket.status === 'Closed'">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :hg="8">
            <switch-input
              v-model="ticket.completed"
              label="Completed?"
              :disabled="disabled" />
          </el-col>

          <el-col :xs="24" :sm="24" :md="12" :lg="8" :hg="8">

            <date-input
              label="Actual Closed"
              v-model="ticket.completedDate"
              :options="dateOptions"
              :disabled="disabled" />

          </el-col>
        </el-row>

        <html-input label="Issue" v-model="ticket.issue" :disabled="disabled" />

        <div v-if="!this.isTowerCo()">
          <strong>Reported by: {{ticket.organisation.name}}</strong>
        </div>

        <div v-else>

         <select-organisation
          type="Telco|Landlord|Tower Supplier|Utility|Backhaul|Tower Company"
          label="Reported by"
          v-model="localData.organisation_id"
          :disabled="disabled" />

        </div>

        <div v-if="this.isTowerCo()">

          <select-contractor
            label="Contractor"
            v-model="ticket.contractor_id"
            :disabled="disabled" />

        </div>

        <div v-else>
          <strong v-if="ticket.contractor">Contractor: {{ticket.contractor.name}}</strong>
        </div>

      </el-tab-pane>


      <el-tab-pane label="Details" v-if="this.isTowerCo()">

        <html-input label="Caused by" v-model="ticket.cause" :disabled="disabled" />

        <html-input label="Fixed by" v-model="ticket.fix" :disabled="disabled" />

      </el-tab-pane>


<!--
      <el-tab-pane label="Scheduled" v-if="this.isTowerCo()">
        <el-row>
          <el-col :span="12">

            <switch-input
              v-model="ticket.scheduledMaint"
              label="Repeated?"
              :disabled="disabled" />

          </el-col>

          <el-col :span="12">
            <select-frequency v-model="localData.schedFrequency" :disabled="disabled" />
          </el-col>

          <el-col :span="12">

            <date-input
              label="Start"
              v-model="ticket.schedStart"
              :options="dateOptions"
              :disabled="disabled" />

          </el-col>

          <el-col :span="12">

            <date-input
              label="End"
              v-model="ticket.schedEnd"
              :options="dateOptions"
              :disabled="disabled" />

          </el-col>
        </el-row>

      </el-tab-pane>
-->
    </el-tabs>

    <el-row>
      <el-form-item v-if="ticket && ticket.id" label="Attachments">
         <files-panel type="site" :id="ticket.site_id"  :process="processKey" :process-id="ticket.id" :disabled="disabled" />
      </el-form-item>
    </el-row>

    <html-input label="Remarks" v-model="ticket.remarks" :disabled="disabled" />

  </el-form>
</edit-pane>

<site-card v-if="localData.site" :site-data="localData.site" map-right />

</el-col>

<el-col v-if="localData && rowData.updated_at" align="right" :span="24">
    <small>Last Update </small>
    <strong>{{formatFriendlyDate (rowData.updated_at)}}</strong><span v-if="rowData.updated_by"> by {{rowData.updated_by}}</span>
</el-col>

</div>
</template>


<script>

import SiteMixins from '@/mixins/SiteMixins'

import {settings} from '@/components/Data'

import SiteCard from '@/components/sites/SiteCard'

import SelectContractor from '@/components/atoms/selects/SelectContractor'

import SelectPriority from '@/components/atoms/selects/SelectPriority'
import SelectTicketCategory from '@/components/atoms/selects/SelectTicketCategory'

import SelectActionStatus from '@/components/atoms/selects/SelectActionStatus'

export default {
  mixins: [SiteMixins],

  components: {
    SelectContractor,
    SelectPriority,
    SelectActionStatus,
    SelectTicketCategory,
    SiteCard
  },

  props: {

    rowData: {
      type: Object,
      required: true
    },

    asset_id: {
      type: Number
    },

    siteId: {
      type: Number
    },

    isAdd: {
      type: Boolean,
      default: false
    },

    editMode: {
      type: Boolean,
      default: false
    },

    hidePanel: {
      type: Boolean,
      default: false
    }

  },


  methods: {

    resetData () {
      this.ticket = this.getTableStruct('tickets')
//      this.ticket.site_id = this.localData.id
      this.ticket.priority = 'Low'
      this.ticket.status = 'Pending'
    },


    success (response) {
//      this.resetData()
      this.$events.fire('refresh-table')
      this.disabled = true
    },


    fail (response) {
      this.disabled = true
    },



    onSave () {

      if (!this.ticket.site_id && this.siteId) {
        this.ticket.site_id = this.siteId
      }

      if (this.ticket.status === 'Completed') {
        this.ticket.completed = true
        this.ticket.completedBy = this.userName()

        if (!this.ticket.completedDate) {
          this.ticket.completedDate = new Date()
        }
      }

      if (!this.ticket.opened) {
        this.ticket.opened = (this.ticket.created_at ? this.ticket.created_at : this.today())
      }
/*
      if (!this.ticket.target) {
        this.ticket.target = this.addDate(this.today(), 7, 'day')
      }
*/
      this.ticket.opened = this.formatDateTimeSql(this.ticket.opened)
      this.ticket.target = this.formatDateTimeSql(this.ticket.target)
      this.ticket.completedDate = this.formatDateTimeSql(this.ticket.completedDate)

      this.ticket.schedStart = this.formatDateTimeSql(this.ticket.schedStart)
      this.ticket.schedNext = this.formatDateTimeSql(this.ticket.schedNext)
      this.ticket.schedLast = this.formatDateTimeSql(this.ticket.schedLast)
      this.ticket.schedEnd = this.formatDateTimeSql(this.ticket.schedEnd)

      this.saveForm(this, '/tickets', this.ticket.id, this.ticket,
        this.ticket.category,
        this.success,
        this.fail)

      //      this.resetData()
    },



    onEdit () {
      this.disabled = false
    },



    onDelete () {
      let msg = this.ticket.organisation
        ? this.ticket.issue + ' for ' + this.ticket.organisation.name
        : (this.ticket.issue ? this.ticket.issue : this.ticket.category)

      this.deleteItem(this, this.ticket.id, '/tickets', msg, this.itemDeleted)
    },


    itemDeleted (response) {
      this.$events.fire('tickettable-refresh-table')
      this.$emit('update-stats')
    },



    onCancel () {
      this.disabled = true
    },



    onClose () {
      this.resetData()
    }


  },



  computed: {

    ticketRef: function () {
      if (this.localData && this.localData.site) {
        return this.localData.site.siteId + '-' + this.formatDate(this.localData.created_at, 'YYYY-MM-DD') + '/' + this.localData.id
      } else {
        return this.formatDate(this.localData.created_at, 'YYYY-MM-DD') + '/' + this.localData.id
      }
    }

  },

  data () {
    return {
      disabled: true,
      processKey: this.rowData.options.processKey,
      dateTimeFormat: settings.dateTimeFormat,
      landOwner: this.rowData.landowner && this.rowData.landowner[0] ? this.rowData.landowner[0].organisation.name : null,
      localData: this.rowData,
      localSiteId: (this.siteId ? this.siteId : (this.rowData.site_id && this.rowData.coverage ? this.rowData.id : this.rowData.site_id)),
      ticket: (this.isAdd ? this.getTableStruct('tickets') : this.rowData),
      dateOptions: {
        shortcuts: [{
          text: 'Today',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: 'Next week',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }, {
          text: 'Next Month',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 30)
            picker.$emit('pick', date)
          }
        }, {
          text: 'Next Year',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 365)
            picker.$emit('pick', date)
          }
        }]
      }
    }
  },

  mounted () {
//    console.log('processKey', this.processKey)

    if (this.rowData && this.rowData.site_id && this.rowData.id) {
//      this.ticket.site_id = this.rowData.id
    } else {
      this.ticket.id = null
    }

  }


}
</script>
